import { inject, Injectable } from '@angular/core'

import { firstValueFrom } from 'rxjs'

import { FleetMapLayer } from '@ti/contracts'
import { ApiService } from '@ti/core/api'
import { Profile } from '@ti/core/auth/services/my.profile'
import { MapLayersProvider } from '@ti/shared/map/services/map-layers.provider'

@Injectable({ providedIn: 'root' })
export class FleetMapLayersProvider extends MapLayersProvider {
  protected readonly api = inject(ApiService)
  protected readonly profile = inject(Profile)

  // Keyed by fleet, so a login-as into another fleet loads that fleet's layers
  protected loaded?: { fleetId: number; layers: Promise<FleetMapLayer[]> }

  public override async getLayers(): Promise<FleetMapLayer[]> {
    const profile = await this.profile.getData()
    if (!profile?.fleetId) {
      return []
    }

    const loaded = this.loaded
    if (loaded && loaded.fleetId === profile.fleetId) {
      return loaded.layers
    }

    const layers = firstValueFrom(this.api.fleet.mapLayers.list$())
    this.loaded = { fleetId: profile.fleetId, layers }
    // Forget a failed request so the next map retries it
    layers.catch(() => {
      if (this.loaded?.layers === layers) this.loaded = undefined
    })
    return layers
  }
}
